module.exports = __webpack_public_path__ + "static/media/facade_avant.2d8ba754.jpg";